module.exports = __webpack_public_path__ + "img/skip-forward-circle.67016ea7.svg";